export interface Printers {
  id: string;
  name: string;
  printerAddress: string;
  obsolete: boolean;
  obsoleteYesNo: string;
}
